import { render, staticRenderFns } from "./Create-role.vue?vue&type=template&id=429d3674"
import script from "./Create-role.vue?vue&type=script&lang=js"
export * from "./Create-role.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Create-role.vue?vue&type=style&index=1&id=429d3674&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports